// extracted by mini-css-extract-plugin
export default {"workUnit":"workUnit_workUnit__fLlGQ","workUnitWithDelete":"workUnit_workUnitWithDelete__vR6OZ","titleValue3":"workUnit_titleValue3__crv0k"};